<div class="question-type__text">
  <h1 class="fs__xxl">Single Choice</h1>
  <p class="fs__md">Participants choose one answer from a list of options. Ideal for when only one response is needed.</p>
  <h2 class="fs__lg">Example</h2>
  <p class="fs__md">Where in Ireland do you live?</p>
  <ul class="question-type__bullet-points">
    <li class="fs__sm">
      <span class="text fw__500">Leinster</span>
    </li>
    <li class="fs__sm">
      <span class="text fw__500">Munster</span>
    </li>
    <li class="fs__sm">
      <span class="text fw__500">Connacht</span>
    </li>
    <li class="fs__sm">
      <span class="text fw__500">Ulster</span>
    </li>
  </ul>
</div>
